import { lazy, Suspense } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../auth/AuthContext'

const LandingRoute = lazy(() =>
  import('./LandingRoute').then((module) => ({ default: module.LandingRoute })),
)

const Blank = () => <div style={{ minHeight: '100%', background: '#050713' }} />

/** `/`: signed-in people go straight to their projects; everyone else sees the landing page. */
export function HomeRoute() {
  const { status } = useAuth()
  if (status === 'authenticated') return <Navigate to="/projects" replace />
  if (status === 'checking') return <Blank />
  return (
    <Suspense fallback={<Blank />}>
      <LandingRoute />
    </Suspense>
  )
}
